
import { defineComponent, computed } from "vue";
import { trans } from "@/globals/translator";
import useArticles from "@/composables/useArticles";
import BlockTitle from "@/components/common/BlockTitle.vue";
import ArticleBlock from "@/components/article/ArticleBlock.vue";
import ArticleCard from "@/components/article/ArticleCard.vue";
import ArticleCardSkeleton from "@/components/article/ArticleCardSkeleton.vue";
import Button from "@moonlight/vue3/components/Button.vue";
import ButtonText from "@moonlight/vue3/components/button/ButtonText.vue";
import ButtonIcon from "@moonlight/vue3/components/button/ButtonIcon.vue";

export default defineComponent({
  components: {
    BlockTitle,
    ArticleBlock,
    ArticleCard,
    ArticleCardSkeleton,
    Button,
    ButtonText,
    ButtonIcon,
  },
  setup() {
    const { fetchArticles, articles, articlesWithMetadata } = useArticles();
    const quantityLastArticles = 3;
    const latestArticles = computed(() => {
      return articles.value.slice(0, quantityLastArticles);
    });

    if (!articles.value.length) {
      fetchArticles();
    }

    return {
      trans,
      latestArticles,
      articlesWithMetadata,
      quantityLastArticles,
    };
  },
});
